import Moment from 'moment'
import Cache from './Cache'
import API from '@/services/API';

const localStorage = 'localStorage'

const pegarValidade = (key) => {
  let data = null
  if (key === keys.token || key === keys.usuario) {
    // Meia hora.
    data = Moment().add(0.5, 'h').toDate()
  } else if (key === keys.estados || key === keys.cidades) {
    // Um mês.
    data = Moment().add(1, 'M').toDate()
  } else {
    // Seis horas.
    data = Moment().add(6, 'h').toDate()
  }

  return data
}

const keys = {
  token: 'token',
  estados: 'estados',
  cidades: 'cidades',
  animais: 'animais',
  descricoes: 'descricoes',
  usuario: 'usuario',
  assinatura: 'assinatura',
  quantidadeSimulacoes: 'quantidadeSimulacoes'
}

const gravar = (key, valor) => {
  if (Cache.disponivel(localStorage)) {
    const dados = {
      valor,
      validade: pegarValidade(key),
      expirado: false
    }
    window.localStorage.setItem(key, JSON.stringify(dados))
  }
}

const pegar = (key) => {
  if (Cache.disponivel(localStorage)) {
    const item = window.localStorage.getItem(key)
    return item ? adicionaTagExpirado(JSON.parse(item)) : item
  }
}

const adicionaTagExpirado = (cache) => {
  // Verifica se a data de validade é anterior a data atual
  cache['expirado'] = Moment(cache.validade).isBefore(Moment())
  return cache
}

function limpar () {
  if (Cache.disponivel(localStorage)) {
    window.localStorage.clear()
    return window.localStorage.length === 0
  }
}

export default {
  limpar,
  animais: {
    pegar: () => pegar(keys.animais),
    gravar: (valor) => gravar(keys.animais, valor)
  },
  estados: {
    pegar: () => pegar(keys.estados),
    gravar: (valor) => gravar(keys.estados, valor)
  },
  descricoes: {
    pegar: () => pegar(keys.descricoes),
    gravar: (valor) => gravar(keys.descricoes, valor)
  },
  token: {
    pegar: () => pegar(keys.token),
    gravar: (valor) => gravar(keys.token, valor)
  },
  usuario: {
    pegar: () => pegar(keys.usuario),
    gravar: (valor) => gravar(keys.usuario, valor)
  },
  assinatura: {
    pegar: () => pegar(keys.assinatura),
    gravar: (valor) => gravar(keys.assinatura, valor)
  },
  quantidadeSimulacoes: {
    pegar: () => pegar(keys.quantidadeSimulacoes),
    gravar: (valor) => {
      API.simulacao.usuario.quantidade(pegar(keys.usuario).valor.usuario.id).then(function(resultado){
        gravar(keys.quantidadeSimulacoes, {quantidade: resultado.data.quantidade})
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/Armazenamento.js